"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../utils");
var _InputRange = _interopRequireDefault(require("./InputRange.styles"));
var _excluded = ["disabled", "labelHidden", "id", "label", "secondaryLabel"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var CustomSlider = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      color: theme.palette.NEUTRAL030,
      height: 4
    },
    thumb: {
      height: 14,
      width: 14,
      backgroundColor: '#fff',
      border: "2px solid ".concat(theme.palette.BLUE400),
      marginTop: -5,
      marginLeft: -12,
      '&:focus, &:hover, &$active': {
        boxShadow: 'inherit'
      }
    },
    active: {},
    valueLabel: {
      left: 'calc(-50% + -6px)',
      color: theme.palette.BLUE400
    },
    track: {
      height: 4,
      borderRadius: 4,
      color: theme.palette.BLUE400
    },
    rail: {
      height: 4,
      borderRadius: 4
    }
  };
})(_Slider.default);
var generatedId = (0, _utils.idGenerator)('InputRange');
var InputRange = function InputRange(_ref) {
  var disabled = _ref.disabled,
    labelHidden = _ref.labelHidden,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? generatedId('-') : _ref$id,
    label = _ref.label,
    secondaryLabel = _ref.secondaryLabel,
    props = _objectWithoutProperties(_ref, _excluded);
  // HOOKS
  var classes = (0, _InputRange.default)();

  // STYLES
  var cssInputLabel = (0, _classnames.default)(classes.inputLabel);
  return /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    fullWidth: true,
    disabled: disabled
  }, !labelHidden && /*#__PURE__*/_react.default.createElement(_core.InputLabel, {
    classes: {
      root: cssInputLabel
    },
    shrink: true,
    htmlFor: id
  }, label, ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: classes.secondaryLabel
  }, secondaryLabel)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.rangeContainer
  }, /*#__PURE__*/_react.default.createElement(CustomSlider, props)));
};
var _default = InputRange;
exports.default = _default;